module.exports = __webpack_public_path__ + "static/media/indexPageImg_guests.0d69d601.png";